import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { NewsletterContent } from "./content";
var NewsletterPage = function(props) {
    var content = props.content;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ _jsx(NewsletterContent, _object_spread({}, props));
};
export { NewsletterPage };
